import * as THREE from 'three'

import Config from '@glass-designer/config'
import BaseObject from './baseObject'
import MathsUtils from '@/utils/mathsUtils'
import GlassDesignerTypes from '../types'


// Point Object
// Displays a crosshair at a single point
export default class PointObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.persistable = false
    this.position = new THREE.Vector2(0, 0)
    this.displayRadius = 10
    this.colour = options.colour || '#000000'
    this.opacity = parseFloat(options.opacity || 1.0)

    this.pointObj = null
    this.objectGeometry = null

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()
  }

  /**
   * Dispose the object
   */
  dispose() {
    super.dispose()

    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.pointObj = null
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    if(this.pointObj) {
      this.pointObj.position.set(this.position.x, this.position.y, 200)
    }
  }


  // Update the position of the point
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Update the display radius of the crosshair at the point
  // Rebuild the scene object
  setDisplayRadius(radius) {
    this.displayRadius = radius
    this.updateSceneObject()
  }


  /**
   * Build the scene object
   */
  updateSceneObject() {
    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.pointObj = null

    this.clearSceneObject()

    // Build crosshair to display the point
    // Set at 0,0. On render will move object position to the position of the point
    var vertices = []
    vertices.push(0, -this.displayRadius, 0, 0, this.displayRadius, 0)
    vertices.push(-this.displayRadius, 0, 0, this.displayRadius, 0, 0)

    this.objectGeometry = new THREE.BufferGeometry();
    this.objectGeometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))

    var crosshairMaterial = new THREE.LineBasicMaterial({
      color: this.colour,
      transparent: true,
      opacity: this.opacity,
    })
    this.pointObj = new THREE.LineSegments(this.objectGeometry, crosshairMaterial)
    this.pointObj.computeLineDistances()
    this.sceneObject.add(this.pointObj)
  }



}
